import { parseISO, format } from "date-fns"
import { PictureDTO } from "./picture.dto"

export class ResourceDTO {
    id: number
    title: string = ''
    thumbnail: PictureDTO = new PictureDTO()
    file: PictureDTO = new PictureDTO()
    mimeType: string = ''
    isForHost: boolean = false
    isForAttendee: boolean = false
    isForAmbassador: boolean = false
    date: string = '';
    month: string = '';
    tags: string[] = []

    constructor(data: Partial<ResourceDTO> = {}) {
        for (let key in data) {
            if (key === 'file' || key === 'thumbnail') {
                this[key] = new PictureDTO(data[key] ?? {});
            } else if (key === 'createdAt') {
                const parsedDate = parseISO(data[key]);
                const date = format(parsedDate, "dd");
                const month = format(parsedDate, "MMMM");
                this.date = date;
                this.month = month;
            } else {
                this[key] = data[key]
            }
        }
    }
}